import actionTypes from "../../actions/actionTypes";

const _initState = {
  isLoading: false,
  chartData: [],
  gridData: [],
};

const spotreba = (state = _initState, action) => {
  switch (action.type) {
    case actionTypes.GET_SPOTREBA_REQUEST:
      return { ...state, isLoading: true };

    case actionTypes.GET_SPOTREBA_SUCCESS:
      const { chartData, gridData } = action.res;

      return { ...state, chartData, gridData, isLoading: false };

    case actionTypes.GET_SPOTREBA_FAILURE:
      return _initState;

    default:
      return state;
  }
};

export default spotreba;
